import PhoneNumber from 'awesome-phonenumber'

export default function (number) {
  if(number && number.length === 12 && !number.startsWith('+')) {
    number = '+' + number
  }

  const pn = new PhoneNumber(number);
  const code = pn.getRegionCode()
  const isValid = pn.isValid()

  if (isValid && code === 'UA') {
    //+38 098 588 08 08
    const phone = pn.getNumber('e164')
    const regexFrom = /(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})/
    const regexTo = "$1 $2 $3 $4 $5"
    return phone.replace(regexFrom, regexTo)
  }

  if (isValid && code === 'PL') {
    //+48 73 208 20 28
    const phone = pn.getNumber('e164')
    const regexFrom = /(\d{2})(\d{2})(\d{3})(\d{2})(\d{2})/
    const regexTo = "$1 $2 $3 $4 $5"
    return phone.replace(regexFrom, regexTo)
  }

  return pn.getNumber('international') || number
}